import { events } from "@planzone/events";
import { Boundaries } from "@planzone/core";
import { file } from "@planzone/dto";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State, Selector } from "./types";
import { initialState } from "./initialState";
import { createSelector } from "./selector";

function handleRequest(
  state: State,
  { document }: Boundaries["downloadDocumentContent"]["request"],
): State {
  const index = state.findIndex((req) => req.document.uuid === document.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { document, request: setRequestStateToPending(), file },
        ...state.slice(index + 1),
      ]
    : [...state, { document, request: setRequestStateToPending(), file }];
}

function handleSuccess(
  state: State,
  { document, file }: Boundaries["downloadDocumentContent"]["success"],
): State {
  const index = state.findIndex((req) => req.document.uuid === document.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { document, request: setRequestStateToSuccess(), file },
        ...state.slice(index + 1),
      ]
    : [...state, { document, request: setRequestStateToSuccess(), file }];
}

function handleFailure(
  state: State,
  { document }: Boundaries["downloadDocumentContent"]["failure"],
): State {
  const index = state.findIndex((req) => req.document.uuid === document.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { document, request: setRequestStateToFailure(), file },
        ...state.slice(index + 1),
      ]
    : [...state, { document, request: setRequestStateToFailure(), file }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.downloadDocumentContentRequested]: handleRequest,
    [events.downloadDocumentContentSucceeded]: handleSuccess,
    [events.downloadDocumentContentFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
